module.exports = global["_"] = require("-!./_tagTester.js");